import { Card, CardBody, Col, Row } from "reactstrap";
import CommonSwitch from "../Common/CommonSwitch";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CUSTOM_SWIRCH, CUSTOM_SWIRCH_LIST } from "../../../../Data/FormWidgets";
import { CustomSwitchs } from "../../../../Constant";

const CustomSwitch = () => {
  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={CustomSwitchs} span={CUSTOM_SWIRCH} />
        <CardBody>
          <Row className="g-3">
            {CUSTOM_SWIRCH_LIST.map(({ id, item, cardClass, formClass, disabled, sm }) => (
              <Col md="4" sm={sm} key={id}>
                <div className={`card-wrapper border rounded-3 ${cardClass} `}>
                  <div className={`form-check-size ${formClass}`}>
                    {item.map((item, index) => (
                      <CommonSwitch color={item} defaultChecked disabled={disabled} key={index} />
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CustomSwitch;
